import type { ReactNode } from "react";

export default function CardGrid({ children }: { children: ReactNode }) {
    return (
        <div className="@container/card-grid">
            <div className="grid grid-cols-1 gap-4 @xl/card-grid:grid-cols-2 @4xl/card-grid:grid-cols-3 @6xl/card-grid:grid-cols-4">
                {children}
            </div>
        </div>
    );
}
